import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService } from '@prekog/common-ui';
import { SpecialityType } from '../../specialities/addspeciality/specialitytype';
import { FindSpecialityTypeByIdRequest } from './findspecialitytypebyidrequest';
import { FindSpecialityTypeByIdResponse } from './findspecialitytypebyidresponse';
import { UpdateSpecialityTypeRequest } from './updatespecialitytyperequest';

@Component({
    selector: 'app-updatespecialitytype',
    templateUrl: './updatespecialitytype.component.html',
    styleUrls: ['./updatespecialitytype.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterModule]
})
export class UpdatespecialitytypeComponent implements OnInit {
    findSpecialityTypeByIdUrl = '/admin/find-specialitytype';

    regeneroBaseUrl: string;

    specialityType: SpecialityType = {};

    specialityTypeForm?: FormGroup;

    updateSpecialityTypeUrl = '/admin/update-specialitytype';

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _fb: FormBuilder
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;

        this.createSpecialityTypeForm();
    }

    ngOnInit(): void {
        this.findSpecialityType();
    }

    findSpecialityType() {
        const lastSegmentOfUrl = window.location.href.split('/').pop();
        const routerLink = lastSegmentOfUrl as string;
        const specialityTypeId = +routerLink;
        const findSpecialityTypeByIdRequest: FindSpecialityTypeByIdRequest = {
            specialityTypeId: specialityTypeId
        };

        this._apiRequestService
            .sendRequest<
                FindSpecialityTypeByIdRequest,
                FindSpecialityTypeByIdResponse
            >(this.regeneroBaseUrl, findSpecialityTypeByIdRequest, true, this.findSpecialityTypeByIdUrl)
            .subscribe((response) => {
                this.specialityType = response.specialityType!;
            });
    }

    createSpecialityTypeForm() {
        this.specialityTypeForm = this._fb.group({
            name: ['', [Validators.required]],
            jobTitle: ['', [Validators.required]]
        });
    }

    collectSpecialityData() {
        this.specialityType = {
            name: this.specialityTypeForm?.controls['name'].value as string | undefined,
            jobTitle: this.specialityTypeForm?.controls['jobTitle'].value as string | undefined
        };
    }

    updateSpecialityType() {
        const updateSpecialityTypeRequest: UpdateSpecialityTypeRequest = {
            specialityType: this.specialityType
        };

        this._apiRequestService
            .sendRequest<
                UpdateSpecialityTypeRequest,
                HttpResponse<any>
            >(this.regeneroBaseUrl, updateSpecialityTypeRequest, true, this.updateSpecialityTypeUrl, true)
            .subscribe();
    }
}
